<div class="selector-header">
  <h3 class="selector-title" mat-dialog-title>
    {{ data.translationKeys.title | translate: data.translationArgs }}
    <button class="close-button" mat-icon-button mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </h3>
</div>
<mat-dialog-content class="editions-carousel">
  <ng-container *ngIf="state$ | async as state">
    <div *ngIf="data.translationKeys.explanation" class="selector-explanation">
      {{ data.translationKeys.explanation | translate: data.translationArgs }}
    </div>
    @if (state.editions.length <= windowSize) {
      <div class="edition-container-wide-screen row">
        <ng-container *ngFor="let edition of state.editions; let index = index; let last = last">
          <div class="col carousel-col col-sm-12 col-xs-12 edition-selection-item">
            <span class="edition-title">
              {{ edition.name }}
            </span>
            <billing-ui-price-display
              [appPrice]="state.appPrice"
              [editionId]="edition.editionId || ''"
              [currencyCode]="state.currency"
              [size]="'large'"
            ></billing-ui-price-display>
            <div class="edition-button">
              <button class="add-to-cart" mat-flat-button color="primary" (click)="selectEdition(edition.editionId)">
                {{ 'FRONTEND.STORE.ADD_TO_CART' | translate }}
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    } @else {
      <div class="carousel-row">
        <div *ngIf="state.editions.length > windowSize" class="button-placeholder left-placeholder">
          <button
            *ngIf="state.window.leftIndex > 0"
            class="window-button"
            mat-button
            (click)="shiftCarousel(state.window, -1)"
          >
            <div>
              <mat-icon class="shift-icon" inline>keyboard_arrow_left</mat-icon>
            </div>
          </button>
        </div>
        <div
          class="carousel"
          [ngClass]="{
            'scrollable-carousel': state.editions.length > windowSize
          }"
        >
          <ng-container *ngFor="let edition of state.editions; let index = index; let last = last">
            <div class="carousel-col scrollable-carousel-col" [ngClass]="" [id]="'carousel-col-' + index.toString()">
              <span class="edition-title">
                {{ edition.name }}
              </span>
              <billing-ui-price-display
                [appPrice]="state.appPrice"
                [editionId]="edition.editionId || ''"
                [currencyCode]="state.currency"
                [size]="'large'"
              ></billing-ui-price-display>
              <div class="edition-button">
                <button class="add-to-cart" mat-flat-button color="primary" (click)="selectEdition(edition.editionId)">
                  {{ 'FRONTEND.STORE.ADD_TO_CART' | translate }}
                </button>
              </div>
            </div>
            <mat-divider *ngIf="!last" vertical></mat-divider>
          </ng-container>
        </div>
        <div *ngIf="state.editions.length > windowSize" class="button-placeholder right-placeholder">
          <button
            *ngIf="state.window.rightIndex < state.editions.length - 1"
            class="window-button"
            mat-button
            (click)="shiftCarousel(state.window, 1)"
          >
            <div>
              <mat-icon class="shift-icon" inline>keyboard_arrow_right</mat-icon>
            </div>
          </button>
        </div>
      </div>
    }
    <div class="compare-row">
      <button mat-button color="primary" (click)="compareEditions()">
        {{ 'FRONTEND.STORE.EDITION_SELECTOR.COMPARE_BUTTON_LABEL' | translate }}
      </button>
    </div>
  </ng-container>
</mat-dialog-content>
